import { render, staticRenderFns } from "./TabPage.vue?vue&type=template&id=4200d49b&scoped=true&"
import script from "./TabPage.vue?vue&type=script&lang=js&"
export * from "./TabPage.vue?vue&type=script&lang=js&"
import style0 from "./TabPage.vue?vue&type=style&index=0&id=4200d49b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4200d49b",
  null
  
)

export default component.exports